const getFooterMenuItems = (categories)=>{
    return categories.map((category)=>{
        return {
            items: category.groups.map((group)=>{
                return {
                    items: group.items.map((item)=>{
                        return {
                            label: item?.title,
                            href: item?.path
                        };
                    }),
                    showAllLink: group.viewAllLink ? {
                        href: group.viewAllLink?.path,
                        label: group.viewAllLink?.title
                    } : null
                };
            }),
            label: category.title
        };
    });
};

export { getFooterMenuItems };
